// Imports
import { GetFormResponse } from '../../../../../../shareables/types/api/main/website/page/form/get';
import CustomFormBuilder from '../shared-components/custom-form-builder';


// Define the accepted props
interface Props {
	pageID: number;
	storybookForm?: GetFormResponse;
	storybookSubmitted?: true;
}


// Function component
const ContactForm: React.FC<Props> = ({ pageID, storybookForm, storybookSubmitted }) => {
	return <CustomFormBuilder pageID={pageID} storybookForm={storybookForm} storybookSubmitted={storybookSubmitted} />;
};

export default ContactForm;
